import { __awaiter, __decorate } from "tslib";
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from './../../services/auth.service';
import { ComponentService } from './../../services/component.service';
import { takeLoginRedirect } from './../../services/login-redirect';
import { DepositOriginService } from './../../services/deposit-origin.service';
import { depositOriginLoginRoute, depositOriginState } from './../../services/deposit-origin';
import { LoginComponent } from './../login';
import { PaymentService } from './../../services/payment.service';
import { SpinnerService } from './../spinner/spinner.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EcurrenciesService } from '../../services/ecurrencies.service';
import { WebsiteThemeService } from './../../services/website-theme.service';
import { GoToPageService } from './../../services/go-to-page.service';
import { PricesService } from '../../services/prices.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { SharedHttp } from "../../services/http-client.service";
import { DocumentExpirationModalComponent } from "../documentation/document-expiration-modal/document-expiration-modal.component";
import { WhitelistAddressApprovedModalComponent } from "../wallet/whitelist-address-approved-modal/whitelist-address-approved-modal.component";
import { EmailGoogleRegistrationComponent } from "../register/email-google-registration/email-google-registration.component";
import { KycReassessmentComponent } from "../kyc-reassessment/kyc-reassessment.component";
import { ExchangeAddressApprovedModalComponent } from '../exchange-address-approved-modal/exchange-address-approved-modal.component';
/**
 * Home Component
 */
let HomeComponent = class HomeComponent {
    constructor(router, httpClient, comp, auth, activated, paymentService, spinner, sanitizer, ecurrenciesService, changeDetector, themeService, goToService, pricesService, webSettingsService, googleAnalyticsService, depositOriginService) {
        this.router = router;
        this.httpClient = httpClient;
        this.comp = comp;
        this.auth = auth;
        this.activated = activated;
        this.paymentService = paymentService;
        this.spinner = spinner;
        this.sanitizer = sanitizer;
        this.ecurrenciesService = ecurrenciesService;
        this.changeDetector = changeDetector;
        this.themeService = themeService;
        this.goToService = goToService;
        this.pricesService = pricesService;
        this.webSettingsService = webSettingsService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.depositOriginService = depositOriginService;
        this.loading = true;
        this.loggedIn = false;
        this.gotoChoosePayment = false;
        this.user = {};
        this.resultOfService = [];
        this.targetUrl = '';
        this.ecurrencies = [];
        this.noArrows = false;
        this.screenWidth = 0;
        this.accentColor = '';
        this.firstColor = '';
        this.secondColor = '';
        this.textColor = '';
        this.borderRadiusChoose = '';
        this.prices = {};
        this.pricesError = false;
        this.changes = {};
        this.changesError = true;
        this.percentUp = '';
        this.percentDown = '';
        this.pricesSpinner = true;
        this.changesSpinner = true;
        this.errorString = 'N/A';
        this.previousUrl = '';
        this.questionnaireSubmitted = true;
        this.isRegionEU = false;
        this.spinner.start();
        document.body.className = '';
        this.themeService.getTheme().subscribe((data) => {
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.firstColor = this.themeService.getStyleAttribute('currency_ring_two_color');
            this.secondColor = this.themeService.getStyleAttribute('currency_ring_one_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusChoose = this.themeService.getStyleAttribute('border_radius_choose');
            this.percentUp = this.themeService.getStyleAttribute('prices_up_color');
            this.percentDown = this.themeService.getStyleAttribute('prices_down_color');
        });
    }
    ngOnInit() {
        localStorage.removeItem('draftData');
        localStorage.removeItem('orderData');
        localStorage.removeItem('orderType');
        localStorage.removeItem('riskLevel');
        localStorage.setItem("questionnaireSubmitted", "true");
        this.user = JSON.parse(localStorage.getItem('user'));
        this.auth.getStatus().subscribe((result) => {
            this.loggedIn = result;
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            this.errorString = this.webSettingsService.getKeyValue("ERROR.NO_ANSWER") !== '' ? this.webSettingsService.getKeyValue("ERROR.NO_ANSWER") : 'N/A';
            this.isRegionEU = this.webSettingsService.getWebSetting('APP_REGION') === 'EU';
        });
        this.pricesService.getPrices().then((data) => {
            if (data) {
                this.prices = this.pricesService.getAllPrices();
                this.pricesSpinner = false;
                this.pricesError = false;
            }
            else {
                this.pricesSpinner = false;
                this.pricesError = true;
            }
        });
        this.pricesService.getChanges().then((result) => {
            if (result) {
                this.changes = this.pricesService.getAllChanges();
                this.changesSpinner = false;
                this.changesError = false;
            }
            else {
                this.changesSpinner = false;
                this.changesError = true;
            }
        });
        this.ecurrenciesService.getEcurrencies().then((success) => {
            this.ecurrencies = this.ecurrenciesService.getAllEcurrencies();
            this.numberOfEcurrencies = this.ecurrencies.length;
        });
        this.paymentService.getMeansOfPayment().subscribe(requestData => {
            this.resultOfService = JSON.parse(requestData['_body']);
            if (this.user !== null) {
                if (this.user['default_mean_of_payment'] === null && this.resultOfService.length > 1) {
                    this.gotoChoosePayment = true;
                }
            }
            this.loading = false;
            this.spinner.stop();
        });
    }
    ngAfterViewInit() {
        this.targetUrl = this.router.url;
        if (this.targetUrl === '/registration') {
            if (this.user === null) {
                document.body.className += ' ' + 'modal-open';
                setTimeout(() => this.comp.openModal(EmailGoogleRegistrationComponent), 0);
            }
            else {
                this.router.navigateByUrl('');
            }
        }
        else if (this.targetUrl.startsWith('/login')) {
            if (this.user === null) {
                document.body.className += ' ' + 'modal-open';
                // the wallet-passphrase reset link the guard kept, if any: the login returns to it (#2740)
                const loginRedirect = takeLoginRedirect();
                setTimeout(() => this.comp.openModal(LoginComponent, null, loginRedirect), 0);
            }
            else {
                this.router.navigate([''], { state: { redirect: this.router.url } });
            }
        }
        else if (this.targetUrl.startsWith('wallet/approve-address')) {
            if (this.targetUrl.endsWith('success')) {
                this.comp.openModal(WhitelistAddressApprovedModalComponent, {
                    isSuccess: true
                });
            }
            else {
                this.comp.openModal(WhitelistAddressApprovedModalComponent, {
                    isSuccess: false
                });
            }
        }
        else if (this.targetUrl.startsWith('/approve-address')) {
            if (this.targetUrl.endsWith('success')) {
                this.comp.openModal(ExchangeAddressApprovedModalComponent, {
                    isSuccess: true
                });
            }
            else {
                this.comp.openModal(ExchangeAddressApprovedModalComponent, {
                    isSuccess: false
                });
            }
        }
        else if (this.targetUrl.startsWith('/kyc-reassessment')) {
            setTimeout(() => this.comp.openModal(KycReassessmentComponent, {
                user: JSON.parse(localStorage.getItem('user'))
            }));
        }
        this.previousUrl = window.history.state.redirect;
        if (this.previousUrl === '/login') {
            if (this.user.verification_documents_expired === true) {
                setTimeout(() => this.comp.openModal(DocumentExpirationModalComponent, { context: 'verification-deadline' }), 0);
            }
            else if (depositOriginState(this.user) !== null) {
                // the deposit trigger wants the statement or the proof of origin: its window in the wallet for a user
                // with one, here on the exchange home page otherwise
                if (depositOriginLoginRoute(this.user) !== '/') {
                    this.router.navigateByUrl(depositOriginLoginRoute(this.user));
                }
                setTimeout(() => this.depositOriginService.open(depositOriginState(this.user)), 0);
            }
            else if (this.user.notify_user_on_expired_document == true && (this.user.personal_document_expired == true || this.user.personal_document_not_exist == true)) {
                setTimeout(() => this.comp.openModal(DocumentExpirationModalComponent), 0);
            }
        }
    }
    upOrDown(value) {
        if (value) {
            if (value.charAt(0) === '+') {
                return 'up';
            }
            else if (value.charAt(0) === '-') {
                return 'down';
            }
        }
        return '';
    }
    goTo(type, currency) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isRegionEU) {
                if (this.user && this.user['risk_level'] === 'High') {
                    this.httpClient.get('market/order/questionnaireFilled?risk_level=' + this.user['risk_level']).subscribe((data) => {
                        if (!data['isQuestionnaireFilled']) {
                            localStorage.setItem('riskLevel', this.user['risk_level']);
                            localStorage.setItem("questionnaireSubmitted", "false");
                            this.router.navigate(['/questionnaire'], { state: { type: type, currency: currency } });
                        }
                        else {
                            this.goToPage(type, currency);
                        }
                    });
                }
                else {
                    this.goToPage(type, currency);
                }
            }
            else {
                if (this.user) {
                    this.router.navigate(['wallet/cryptocurrencies'], { state: { type: type, currency: currency } });
                }
                else {
                    this.goToPage(type, currency);
                }
            }
        });
    }
    goToPage(type, currency) {
        this.goToService.goTo(type, currency, null);
        let array = [];
        array.push({
            'event': 'buySellCTAclick',
            button: type,
            cryptoCurrency: currency
        });
        this.googleAnalyticsService.pushGAEvents(array);
    }
    onResize(event) {
        this.noArrows = false;
        this.screenWidth = event.target.innerWidth;
        if (this.numberOfEcurrencies <= 3 && this.screenWidth >= 770) {
            this.noArrows = true;
            this.changeDetector.detectChanges();
        }
    }
    setCookie(name, val) {
        const date = new Date();
        const value = val;
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
    }
};
HomeComponent.ctorParameters = () => [
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: AuthService },
    { type: ActivatedRoute },
    { type: PaymentService },
    { type: SpinnerService },
    { type: DomSanitizer },
    { type: EcurrenciesService },
    { type: ChangeDetectorRef },
    { type: WebsiteThemeService },
    { type: GoToPageService },
    { type: PricesService },
    { type: WebClientService },
    { type: GoogleAnalyticsService },
    { type: DepositOriginService }
];
__decorate([
    ViewChild('scrollMe', { static: true })
], HomeComponent.prototype, "myScrollContainer", void 0);
__decorate([
    HostListener('window:resize', ['$event'])
], HomeComponent.prototype, "onResize", null);
HomeComponent = __decorate([
    Component({
        selector: 'ecd-home',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./home.component.html")).default
    })
], HomeComponent);
export { HomeComponent };
